import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import logo from "../../assets/images/logo-default.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import fingerprint from "../../assets/images/icon_login/fingerprint.svg";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import eye from "../../assets/images/icon_login/eye.svg";
import intro from "../../assets/images/icon_login/intro-confirm-data.svg";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createPassword } from "../../core/service/api_profile";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import CustomApp from "../../core/models/customApp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { getBalance } from "../../core/service/api_balance";
import { setLastService } from "../../core/feature/lastService/lastServiceSlice";
import { setToken } from "../../core/feature/token/tokenSlice";

const ConfirmationDataIntroMobile = () => {
  const { t } = useTranslation();
  const language: String = useAppSelector((state) => state.language.language);

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const location: any = useLocation();
  const [email, setEmail] = useState("");
  const [resLogin, setResLogin] = useState<any>({});
  const [credential, setCredential] = useState<any>({});
  const [phone, setPhone] = useState("");
  const [typePassword, setTypePassword] = useState("password");
  const [typePassword2, setTypePassword2] = useState("password");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  var CryptoJS = require("crypto-js");

  useEffect(() => {
    setCredential(location.state.credential);
    setEmail(location.state.email);
    setPhone(location.state.phone);
  }, []);

  const createPassword = async () => {
    navigate("/create-password", {
      replace: true,
      state: {
        username: credential?.username,
        email: email,
        phone: phone,
      },
    });
  };
  const skip = async () => {
    dispatch(setLoading(true));
    API.login(credential)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(setLastService(res.data.user.lastService));
        dispatch(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck().then((resCredential) => {
          if (resCredential.data.user.accounts[0].roles.includes("ROLE_USER")) {
            var auto = "1";
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(credential),
              "credential"
            ).toString();
            localStorage.setItem("credential", ciphertext);
            localStorage.setItem("auto_login", auto);
            dispatch(setUser(resCredential.data.user));
            getBalance().then((balance) => {
              dispatch(setBalance(balance.data.balance));

              if (res.data.user.lastService == "KATALIS") {
                var languageUpper = language.toUpperCase();
                API.getCustomApps(
                  resCredential.data.activeCompany.id,
                  languageUpper
                ).then((resCustom: any) => {
                  console.log(resCustom.data);
                  dispatch(setCustomApp(resCustom.data));
                  navigate("/home", { replace: true });
                });
              } else {
                dispatch(removeUser());
                dispatch(removeBalance());
                dispatch(removeCompany());
                toast.error(t("LOGIN.accessInvalid"));
                navigate("/login", { replace: true });
              }
            });
          } else {
            return toast.error(t("LOGIN.accessInvalid"));
          }
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        // toast.error(t("LOGIN.wrongLogin"));
      });
  };
  return (
    <>
      <div className="min-h-screen font-montserrat h-full p-10 bg-psp-primary">
        <div className="mt-24">
          <img src={logo} className="w-52 mx-auto" />
        </div>
        <div className="mt-10 flex flex-col items-center">
          <LazyLoadImage
            effect="blur"
            src={intro}
            alt=""
            className="h-[345px]"
          />
          <p className="font-medium text-sm text-[#B9B9B9] text-center">
            {t("CONFIRMATIONDATA.description")}
          </p>
          <button
            onClick={() => createPassword()}
            className="px-4 mt-4 bg-[#0054E6] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
          >
            {t("CONFIRMATIONDATA.changePassword")}
          </button>
          <button
            onClick={() => skip()}
            className="px-4 mt-2 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
          >
            {t("CONFIRMATIONDATA.skip")}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationDataIntroMobile;
